"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchStatus = exports.MessageVisibilityEnum = exports.HealthEnum = exports.MessageBodyTypeEnum = void 0;
var MessageBodyTypeEnum;
(function (MessageBodyTypeEnum) {
    MessageBodyTypeEnum["AUDIO_SHARED"] = "co.vendorflow.core.AudioShared@0.1";
    MessageBodyTypeEnum["BASE"] = "co.vendorflow.core.Base@0.1";
    MessageBodyTypeEnum["OPEN_WINDOW_INTRO"] = "co.vendorflow.core.user.OpenWindowIntroduction@0.1";
    MessageBodyTypeEnum["CAPACITY_REQUEST_TMSEZ"] = "co.vendorflow.core.logistics.CapacityRequestTmsez@0.1";
    MessageBodyTypeEnum["CAPACITY_SIMPLE_REQUEST"] = "co.vendorflow.logistics.capacity.SimpleRequest@0.2";
    MessageBodyTypeEnum["CAPACITY_UNSTRUCTURED_REQUEST"] = "co.vendorflow.core.logistics.UnstructuredRequest@0.1";
    MessageBodyTypeEnum["CHAT"] = "co.vendorflow.core.Chat@0.1";
    MessageBodyTypeEnum["CHATBOT_STATUS"] = "co.vendorflow.automation.chatbot.ChatbotStatus@0.1";
    MessageBodyTypeEnum["CONDITION_CHECK_REPLY"] = "co.vendorflow.logistics.status.ConditionCheckReply@0.1";
    MessageBodyTypeEnum["CONDITION_CHECK_REQUEST"] = "co.vendorflow.logistics.status.ConditionCheckRequest@0.1";
    MessageBodyTypeEnum["DELIVERY_ERROR"] = "co.vendorflow.core.error.DeliveryError@0.1";
    MessageBodyTypeEnum["DOCUMENT_RATE_CONFIRMATION"] = "co.vendorflow.logistics.document.RateConfirmation@0.2";
    MessageBodyTypeEnum["DOCUMENT_REQUEST"] = "co.vendorflow.document.DocumentRequest@0.1";
    MessageBodyTypeEnum["ENDPOINT_BLOCKED"] = "co.vendorflow.core.consent.EndpointBlocked@0.1";
    MessageBodyTypeEnum["ENDPOINT_UNBLOCKED"] = "co.vendorflow.core.consent.EndpointUnblocked@0.1";
    MessageBodyTypeEnum["ELECTRONIC_SIGNATURE_APPLIED"] = "co.vendorflow.document.ElectronicSignatureApplied@0.1";
    MessageBodyTypeEnum["ELECTRONIC_SIGNATURE_REQUEST"] = "co.vendorflow.document.ElectronicSignatureRequest@0.1";
    MessageBodyTypeEnum["FLOW_OUTCOME"] = "co.vendorflow.automation.FlowOutcome@0.2";
    MessageBodyTypeEnum["FORM_REQUEST"] = "co.vendorflow.automation.FormRequest@0.1";
    MessageBodyTypeEnum["FORM_RESPONSE"] = "co.vendorflow.automation.FormResponse@0.1";
    MessageBodyTypeEnum["HELLO"] = "co.vendorflow.hyper.scaffold.Hello@0.2";
    MessageBodyTypeEnum["IDENTITY_UPDATED"] = "co.vendorflow.workspaces.identity.IdentityUpdated@0.1";
    MessageBodyTypeEnum["IMAGE_SHARED"] = "co.vendorflow.core.ImageShared@0.1";
    MessageBodyTypeEnum["INCOMING_DOCUMENT_SHARED"] = "co.vendorflow.core.DocumentShared@0.1";
    MessageBodyTypeEnum["INCOMING_LOCATION_SHARED"] = "co.vendorflow.geo.LocationShared@0.1";
    MessageBodyTypeEnum["MANAGE_SUBSCRIPTION"] = "co.vendorflow.core.consent.ManageSubscription@0.1";
    MessageBodyTypeEnum["MEMBERS_ADDED"] = "co.vendorflow.workspaces.channel.MembersAdded@0.1";
    MessageBodyTypeEnum["MEMBERS_REMOVED"] = "co.vendorflow.workspaces.channel.MembersRemoved@0.1";
    MessageBodyTypeEnum["MESSAGE_FORWARDED"] = "co.vendorflow.workspaces.MessageForwarded@0.1";
    MessageBodyTypeEnum["ONE_TIME_LOCATION_REQUEST"] = "co.vendorflow.geo.LocationRequest@0.1";
    MessageBodyTypeEnum["OPEN_WINDOW_REQUEST"] = "co.vendorflow.core.user.OpenWindowRequest@0.1";
    MessageBodyTypeEnum["RECRUIT"] = "com.canaanxpress.hr.Recruit@0.1";
    MessageBodyTypeEnum["START_CHATBOT"] = "co.vendorflow.automation.chatbot.StartChatbot@0.1";
    MessageBodyTypeEnum["STATUS_CONTAINER_READY"] = "co.vendorflow.logistics.status.ContainerReady@0.1";
    MessageBodyTypeEnum["STATUS_ETA_REQUEST"] = "co.vendorflow.logistics.status.EtaRequest@0.1";
    MessageBodyTypeEnum["STATUS_LOCATION_REQUEST"] = "co.vendorflow.logistics.status.ShipmentLocationRequest@0.1";
    MessageBodyTypeEnum["VIDEO_SHARED"] = "co.vendorflow.core.VideoShared@0.1";
})(MessageBodyTypeEnum = exports.MessageBodyTypeEnum || (exports.MessageBodyTypeEnum = {}));
var HealthEnum;
(function (HealthEnum) {
    HealthEnum["OK"] = "OK";
    HealthEnum["INFO"] = "INFO";
    HealthEnum["WARN"] = "WARN";
    HealthEnum["SEVERE"] = "SEVERE";
    HealthEnum["FATAL"] = "FATAL";
})(HealthEnum = exports.HealthEnum || (exports.HealthEnum = {}));
var MessageVisibilityEnum;
(function (MessageVisibilityEnum) {
    MessageVisibilityEnum["INTERNAL"] = "INTERNAL";
})(MessageVisibilityEnum = exports.MessageVisibilityEnum || (exports.MessageVisibilityEnum = {}));
var DispatchStatus;
(function (DispatchStatus) {
    DispatchStatus["INGESTING"] = "INGESTING";
    DispatchStatus["ERROR_INGESTION"] = "ERROR_INGESTION";
    DispatchStatus["PERSISTED"] = "PERSISTED";
    DispatchStatus["ROUTING"] = "ROUTING";
    DispatchStatus["ERROR_ROUTING"] = "ERROR_ROUTING";
    DispatchStatus["ROUTED"] = "ROUTED";
    DispatchStatus["PENDING_TRANSMISSION"] = "PENDING_TRANSMISSION";
    DispatchStatus["TRANSMITTED"] = "TRANSMITTED";
    DispatchStatus["ERROR_TRANSMISSION"] = "ERROR_TRANSMISSION";
    DispatchStatus["DELIVERED"] = "DELIVERED";
    DispatchStatus["ERROR_DELIVERY"] = "ERROR_DELIVERY";
    DispatchStatus["READ"] = "READ";
})(DispatchStatus = exports.DispatchStatus || (exports.DispatchStatus = {}));
